<template>
    <template v-if="sortConfig !== null && sortConfig !== undefined">
        <div class="jb-field">
            <label :for="sortConfig.fieldname" class="jb-label">{{ sortConfig.placeholder }}</label>
            <select class="jb-input jb-input--select" :name="sortConfig.fieldname" :id="sortConfig.fieldname" v-on:input="updateValue($event.target.value)"
                    :value="modelValue">
                <option v-for="sortOption in sortOptions" :value="sortOption.value" v-bind:key="sortOption.value">
                    {{ sortOption.label }}
                </option>
            </select>
        </div>
    </template>
</template>

<script>
export default {
    name: 'FilterInput',
    props: {
        modelValue: {
            required: true
        },
        sortConfig: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    computed: {
        sortOptions() {
            let sortOptions = {};
            for (let sortOption in this.sortConfig.fields) {
                sortOptions[sortOption + 'asc'] = {
                    'label': this.sortConfig.fields[sortOption] + ' asc',
                    'value': sortOption + ':asc',
                }
                sortOptions[sortOption + 'desc'] = {
                    'label': this.sortConfig.fields[sortOption] + ' desc',
                    'value': sortOption + ':desc',
                }
            }
            return sortOptions;
        }
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value);
        }
    }
}
</script>
